import type { AbilityClass, AbilityOptionsOf } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'

import type { User } from '~/types/user.type'
import { AbilityBuilder, fieldPatternMatcher, mongoQueryMatcher, PureAbility } from '@casl/ability'
import { defineClientAbilities } from './subject/client'
import { defineDashboardAbilities } from './subject/dashboard'
import { defineGlobalSearchAbilities } from './subject/globalSearch'
import { defineInvoiceAbilities } from './subject/invoice'
import { defineProjectAbilities } from './subject/project'
import { defineRecurringInvoiceAbilities } from './subject/recurringInvoice'
import { defineReportAbilities } from './subject/report'
import { defineSchedulingAbilities } from './subject/scheduling'
import { defineSettingsAbilities } from './subject/settings'
import { defineTaskAbilities } from './subject/task'
import { defineTaskListAbilities } from './subject/taskList'
import { defineTimeEntryAbilities } from './subject/timeEntry'

const Ability = PureAbility as AbilityClass<AppAbility>
const abilityOptions: AbilityOptionsOf<AppAbility> = { conditionsMatcher: mongoQueryMatcher, fieldMatcher: fieldPatternMatcher }

export function appAbility(user?: User) {
  const abilityBuilder = new AbilityBuilder<AppAbility>(Ability)

  if (!user)
    return abilityBuilder.build(abilityOptions)

  defineDashboardAbilities(abilityBuilder, user)
  defineSettingsAbilities(abilityBuilder, user)
  defineGlobalSearchAbilities(abilityBuilder, user)
  defineClientAbilities(abilityBuilder, user)
  defineProjectAbilities(abilityBuilder, user)
  defineTaskListAbilities(abilityBuilder, user)
  defineTaskAbilities(abilityBuilder, user)
  defineTimeEntryAbilities(abilityBuilder, user)
  defineReportAbilities(abilityBuilder, user)
  defineInvoiceAbilities(abilityBuilder, user)
  defineRecurringInvoiceAbilities(abilityBuilder, user)
  defineSchedulingAbilities(abilityBuilder, user)

  return abilityBuilder.build(abilityOptions)
}
